import { useSyncExternalStore } from 'react';

// Tailwind's breakpoints (tailwind.config.js keeps the defaults).
export const SCREEN = { sm: '(min-width: 640px)', md: '(min-width: 768px)', lg: '(min-width: 1024px)' };

// One MediaQueryList per query, shared by every component that asks.
const lists = new Map();
const list = (query) => {
  if (!lists.has(query)) lists.set(query, window.matchMedia(query));
  return lists.get(query);
};
const subscribers = new Map();
const subscribe = (query) => {
  if (!subscribers.has(query)) {
    subscribers.set(query, (onChange) => {
      const mql = list(query);
      mql.addEventListener('change', onChange);
      return () => mql.removeEventListener('change', onChange);
    });
  }
  return subscribers.get(query);
};
const noSubscribe = () => () => {};

/**
 * Whether a media query matches, read during render. Draw a layout only where it is
 * seen instead of drawing both and hiding one with `hidden sm:grid`: on a phone the
 * hidden desktop markup was most of every page, and React built it again on every
 * refresh. Without matchMedia (jsdom) it reports `fallback`.
 */
export function useMediaQuery(query, fallback = true) {
  const supported = typeof window !== 'undefined' && typeof window.matchMedia === 'function';
  return useSyncExternalStore(
    supported ? subscribe(query) : noSubscribe,
    () => (supported ? list(query).matches : fallback),
    () => fallback,
  );
}
